import { Network } from 'data/network/network.types';
import { WithAuditDetails, AuditDetails, Operation } from 'data/types';
import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';

export default function getNetworkDataToSubmit(
  network: Network,
  originalNetwork: Network | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): WithAuditDetails<Network> {
  const networkBody: WithAuditDetails<Network> = {
    data: network,
  };

  let actionType = AuditActionType.NETWORK_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.NETWORK_EDIT;
    isEdit = true;
  }

  if (isAuditEnabled) {
    const auditDetails = getAuditDetails(
      isAuditEnabled,
      userId,
      userName,
      getAuditFieldInfo(network, null, isEdit, originalNetwork),
      network.networkId,
      AuditService.NETWORK,
      actionType,
    );
    networkBody.auditDetails = auditDetails as AuditDetails;
  }

  return networkBody;
}
